// Global Instructions Rule Applied!

export const SET_JOURNAL_ENTRIES = 'journal_entries/SET_JOURNAL_ENTRIES' as const
export const APPEND_JOURNAL_ENTRIES = 'journal_entries/APPEND_JOURNAL_ENTRIES' as const
export const SET_ACTIVE_FILTERS = 'journal_entries/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'journal_entries/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'journal_entries/CLEAR_ACTIVE_FILTERS' as const
export const UPDATE_JOURNAL_ENTRY_RECORD = 'journal_entries/UPDATE_JOURNAL_ENTRY_RECORD' as const
export const REMOVE_JOURNAL_ENTRY = 'journal_entries/REMOVE_JOURNAL_ENTRY' as const
